import { Collapse, CollapseDropdownContainer } from '@trarc/pc-shared';
import styled from 'styled-components';

export const QuestionnaireContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex-shrink: 0;
`;

export const QuestionnaireSection = styled(Collapse)`
  width: 100%;
  ${CollapseDropdownContainer} {
    padding: 0 1rem;
  }
`;
